import type { MenuItem } from '~/types/strapi';

export const useLocalizedUrl = () => {
  const { locale } = useI18n();

  return (item: MenuItem) => {
    const url = item.url || item.page?.slug;
    if (!url) return '';
    // If it's already a full URL, return as is
    if (url.startsWith('http')) return url;

    // at this point we have to make the url absolute if it is not already
    if (!url.startsWith('/')) {
      return `/${url}`;
    }

    // If it's the default locale, return without prefix
    const config = useRuntimeConfig();
    const defaultLocale = config.public.i18n?.defaultLocale || 'de';
    if (locale.value === defaultLocale) return url;
    // For other locales, add the locale prefix
    return `/${locale.value}${url}`;
  };
};

export const useLocalizedPath = (path: string) => {
  if (!path) return '';
  if (path.startsWith('http')) return path;

  let normalizedPath = path;

  if (!normalizedPath.startsWith('/')) normalizedPath = `/${normalizedPath}`;

  const localePath = useLocalePath();
  return localePath(normalizedPath);
};
